var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "managePreparencePopup" } },
    [
      _c("div", { staticClass: "col-sm-12 col-xs-12", attrs: { id: "body" } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "div",
              { staticClass: "nav nav-tabs mt-5", attrs: { role: "tablist" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "nav-item",
                    class: { active: _vm.activeName == "first" },
                    attrs: { role: "presentation" },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "nav-link",
                        attrs: { role: "tab", "data-toggle": "tab" },
                      },
                      [_vm._v("Registration Tracker")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-md-12 col-xs-12 col-sm-12 mb-5 mt-30",
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _vm._m(0),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-md-4 col-sm-5 col-xs-12 custom-dropdown xs-pd-lt-0",
                            },
                            [
                              _c("multiselect", {
                                staticClass: "multiselect-single-dropdown",
                                attrs: {
                                  showLabels: false,
                                  "close-on-select": true,
                                  "allow-empty": false,
                                  "open-direction": "bottom",
                                  searchable: false,
                                  options: _vm.options.map(
                                    (option) => option.value
                                  ),
                                  "custom-label": (option) =>
                                    _vm.options.find((x) => x.value === option)
                                      .label,
                                  placeholder: "Select",
                                },
                                model: {
                                  value: _vm.commonDateFormat,
                                  callback: function ($$v) {
                                    _vm.commonDateFormat = $$v
                                  },
                                  expression: "commonDateFormat",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _vm._m(1),
                    _c(
                      "div",
                      {
                        staticClass:
                          "box_wrapper_xs col-md-12 col-sm-12 col-xs-12",
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _vm._m(2),
                          _vm._m(3),
                          _c(
                            "div",
                            { staticClass: "col-md-12 col-sm-12 col-xs-12" },
                            [
                              _c(
                                "div",
                                { staticClass: "row member-box-wrapper" },
                                [
                                  _vm._m(4),
                                  _vm._m(5),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-md-6 col-xs-6 col-sm-6",
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "pr-0 xs-pd-lt-0",
                                            class:
                                              _vm.roleId === 5 ||
                                              _vm.roleId === 7
                                                ? "col-md-4 col-sm-4 col-xs-4"
                                                : "col-md-6 col-sm-6 col-xs-6",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "heading hideHeading heading-type",
                                              },
                                              [
                                                _vm._v(" Renewal timeframe "),
                                                _c(
                                                  "el-popover",
                                                  {
                                                    staticClass: "hide-xs",
                                                    attrs: {
                                                      placement: "bottom-end",
                                                      trigger: "click",
                                                      width: "350",
                                                    },
                                                    on: {
                                                      show: function ($event) {
                                                        _vm.infoActive = true
                                                      },
                                                      hide: function ($event) {
                                                        _vm.infoActive = false
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "preference_popover_txt",
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "Changes will apply to new records only. Changes will not apply to existing records."
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    !_vm.infoActive
                                                      ? _c("img", {
                                                          staticClass:
                                                            "info-img",
                                                          attrs: {
                                                            slot: "reference",
                                                            src: "/static/images/icons/info_icon.svg",
                                                            alt: "info-icon",
                                                          },
                                                          slot: "reference",
                                                        })
                                                      : _vm._e(),
                                                    _vm.infoActive
                                                      ? _c("img", {
                                                          staticClass:
                                                            "info-img",
                                                          attrs: {
                                                            slot: "reference",
                                                            src: "/static/images/icons/info_icon_active.svg",
                                                            alt: "infoactive-icon",
                                                          },
                                                          slot: "reference",
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "mobile-heading" },
                                              [
                                                _vm._v(" RTF "),
                                                _c(
                                                  "base-tooltip",
                                                  {
                                                    attrs: {
                                                      content:
                                                        "Renewal timeframe",
                                                      placement: "top",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-info-circle",
                                                      attrs: {
                                                        "aria-hidden": "true",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm.roleId !== 5 &&
                                        _vm.roleId !== 7 &&
                                        _vm.roleId !== 11
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-6 col-sm-6 col-xs-6 pr-0 xs-pd-lt-0",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "heading hideHeading heading-type",
                                                    attrs: {
                                                      "data-toggle": "tooltip",
                                                      "data-placement": "top",
                                                      title:
                                                        "Emergo recommended Renewal timeframe",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " Emergo recommended Renewal timeframe "
                                                    ),
                                                    _c(
                                                      "el-popover",
                                                      {
                                                        staticClass: "hide-xs",
                                                        attrs: {
                                                          placement:
                                                            "bottom-end",
                                                          trigger: "click",
                                                          width: "350",
                                                        },
                                                        on: {
                                                          show: function (
                                                            $event
                                                          ) {
                                                            _vm.infoActiveERTF = true
                                                          },
                                                          hide: function (
                                                            $event
                                                          ) {
                                                            _vm.infoActiveERTF = false
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "preference_popover_txt",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "The recommended renewal timeframe are set based on the experience of Emergo by UL. Timeframes are determined by the average length of time it takes a manufacturer to prepare, submit and complete the renewal process."
                                                              ),
                                                            ]),
                                                            _c("span", [
                                                              _vm._v(
                                                                " In markets where we generally do not provide extensive regulatory consulting, the default is set to 12 months prior to expiration."
                                                              ),
                                                            ]),
                                                            _c("span", [
                                                              _vm._v(
                                                                " Changes will apply to new records only. Changes will not apply to existing records."
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        !_vm.infoActiveERTF
                                                          ? _c("img", {
                                                              staticClass:
                                                                "info-img",
                                                              attrs: {
                                                                slot: "reference",
                                                                src: "/static/images/icons/info_icon.svg",
                                                                alt: "info-icon",
                                                              },
                                                              slot: "reference",
                                                            })
                                                          : _vm._e(),
                                                        _vm.infoActiveERTF
                                                          ? _c("img", {
                                                              staticClass:
                                                                "info-img",
                                                              attrs: {
                                                                slot: "reference",
                                                                src: "/static/images/icons/info_icon_active.svg",
                                                                alt: "infoactive-icon",
                                                              },
                                                              slot: "reference",
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-heading",
                                                  },
                                                  [
                                                    _vm._v(" ERTF "),
                                                    _c(
                                                      "base-tooltip",
                                                      {
                                                        attrs: {
                                                          content:
                                                            "Emergo recommended Renewal timeframe",
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-info-circle",
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.roleId === 5 || _vm.roleId === 7
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-4 col-sm-4 col-xs-4 pr-0 xs-pd-lt-0",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "heading hideHeading heading-type",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Earliest Renewal Date"
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-heading",
                                                  },
                                                  [
                                                    _vm._v(" ERD "),
                                                    _c(
                                                      "base-tooltip",
                                                      {
                                                        attrs: {
                                                          content:
                                                            "Earliest Renewal Date",
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-info-circle",
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.roleId === 5 || _vm.roleId === 7
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-4 col-sm-4 col-xs-4 pr-0 xs-pd-lt-0",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "heading hideHeading heading-type",
                                                  },
                                                  [_vm._v("Renewal deadline")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mobile-heading",
                                                  },
                                                  [
                                                    _vm._v(" RD "),
                                                    _c(
                                                      "base-tooltip",
                                                      {
                                                        attrs: {
                                                          content:
                                                            "Renewal deadline",
                                                          placement: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-info-circle",
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]),
        _c("div", { staticClass: "col-md-12 col-sm-12 col-xs-12 container1" }, [
          _c("div", { staticClass: "section" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-md-12 col-sm-12 col-xs-12 scrollable-content content",
              },
              _vm._l(_vm.certificateAlertDataList, function (row, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "row member-box-wrapper" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-3 col-sm-3 col-xs-3 pr-0 xs-pd-lt-0",
                      },
                      [
                        _c("span", { staticClass: "wordbreak alert_text" }, [
                          _vm._v(_vm._s(row.country_name)),
                        ]),
                      ]
                    ),
                    _c("div", { staticClass: "col-md-3 col-sm-3 col-xs-3" }, [
                      _c("span", { staticClass: "wordbreak alert_text" }, [
                        _vm._v(_vm._s(row.certificate_type)),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-md-6 col-xs-6 col-sm-6" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-3 col-md-3 xs-pd-lt-0 lg-pd-rt-10",
                            class:
                              _vm.roleId === 5 || _vm.roleId === 7
                                ? "col-sm-4 col-xs-4 xs-pd-rt-0 "
                                : "col-sm-3 col-xs-6 xs-pd-rt-10",
                          },
                          [
                            _c("base-input-number", {
                              staticClass: "rtf",
                              attrs: { min: 0 },
                              on: {
                                change: function ($event) {
                                  return _vm.triggerInput(
                                    row.certificate_type_id
                                  )
                                },
                                keyup: function ($event) {
                                  return _vm.triggerInput(
                                    row.certificate_type_id
                                  )
                                },
                              },
                              model: {
                                value: row.alertBeforeMonths,
                                callback: function ($$v) {
                                  _vm.$set(
                                    row,
                                    "alertBeforeMonths",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "row.alertBeforeMonths",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.roleId == 5 || _vm.roleId == 7
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-offset-1 col-md-offset-1 col-lg-3 col-md-3 col-sm-4 col-xs-4 xs-pd-rt-0 xs-pd-lt-5 lg-pd-rt-10",
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    _c("base-input-number", {
                                      attrs: { min: 0 },
                                      on: {
                                        change: function ($event) {
                                          return _vm.triggerInput(
                                            row.certificate_type_id
                                          )
                                        },
                                        keyup: function ($event) {
                                          return _vm.triggerInput(
                                            row.certificate_type_id
                                          )
                                        },
                                      },
                                      model: {
                                        value:
                                          row.certificateMinimumRenewalDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            row,
                                            "certificateMinimumRenewalDate",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression:
                                          "row.certificateMinimumRenewalDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.roleId == 5 || _vm.roleId == 7
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-lg-offset-1 col-md-offset-1 col-lg-3 col-md-3 col-sm-4 col-xs-4 xs-pd-rt-0 xs-pd-lt-5 lg-pd-rt-10",
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    _c("base-input-number", {
                                      attrs: { min: 0 },
                                      on: {
                                        change: function ($event) {
                                          return _vm.triggerInput(
                                            row.certificate_type_id
                                          )
                                        },
                                        keyup: function ($event) {
                                          return _vm.triggerInput(
                                            row.certificate_type_id
                                          )
                                        },
                                      },
                                      model: {
                                        value: row.certificateRenewalDeadline,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            row,
                                            "certificateRenewalDeadline",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression:
                                          "row.certificateRenewalDeadline",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-3 col-sm-3 col-xs-4 pl-0 months_bef_wrapper",
                              },
                              [
                                _c("span", { staticClass: "alert_text" }, [
                                  _vm._v("months before"),
                                ]),
                              ]
                            ),
                        _vm.roleId !== 5 &&
                        _vm.roleId !== 7 &&
                        _vm.roleId !== 11
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-3 col-md-3 col-sm-3 col-xs-6 xs-pd-lt-0 xs-pd-rt-10 lg-pd-rt-10",
                                },
                                [
                                  _c("span", [
                                    _c("input", {
                                      staticClass:
                                        "form-control xs-pd-6 input_number",
                                      attrs: { type: "text", disabled: "" },
                                      domProps: {
                                        value:
                                          row.emergo_recommended_renewal_timeframe,
                                      },
                                    }),
                                  ]),
                                ]
                              ),
                              _vm._m(6, true),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "col-xs-12 col-sm-12 col-md-12 footer" }, [
        _c(
          "div",
          {
            staticClass:
              "col-md-2 col-sm-3 col-xs-5 col-md-offset-7 col-sm-offset-5 xs-pd-lt-0",
          },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-block emergo-white-button",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("closepopup")
                  },
                },
              },
              [_vm._v(" Cancel ")]
            ),
          ]
        ),
        _c(
          "div",
          { staticClass: "col-md-3 col-xs-7 col-sm-4 xs-pd-lt-0 xs-pd-rt-0" },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-block emergo-green-button",
                attrs: {
                  type: "button",
                  disabled:
                    _vm.updateSet.length === 0 &&
                    _vm.commonDateFormat === _vm.tempCommonDateFormat,
                },
                on: { click: _vm.saveChanges },
              },
              [_vm._v(" Save Changes ")]
            ),
          ]
        ),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-md-4 col-sm-4 col-xs-12 xs-pd-lt-0" },
      [
        _c("span", { staticClass: "heading" }, [
          _vm._v("Display Expiration Date"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-md-12 col-sm-12 col-xs-12 mb-10 xs-pd-0" },
      [_c("hr")]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-md-12 col-sm-12 col-xs-12 xs-pd-lt-0" },
      [_c("span", { staticClass: "heading" }, [_vm._v("Expiration Status")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "col-md-12 col-sm-12 col-xs-12 expiry-status-desc xs-pd-tp-0",
      },
      [
        _c("span", [
          _vm._v(
            "Indicate how many months prior to the expiration date you would like a record to change from an Active to Expiring Soon status."
          ),
        ]),
        _c("span", [
          _vm._v(
            "If you have opted to receive an Expiring Soon alert via your Notifications setting, the below also determines when that email will be sent."
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-md-3 col-sm-3 col-xs-3 pr-0 xs-pd-lt-0" },
      [_c("span", { staticClass: "heading heading-type" }, [_vm._v("Country")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-md-3 col-sm-3 col-xs-3 pr-0 xs-pd-lt-0" },
      [
        _c("span", { staticClass: "heading heading-type" }, [
          _vm._v("Record Type"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-md-3 col-sm-3 col-xs-4 pl-0 months_bef_wrapper" },
      [_c("span", { staticClass: "alert_text" }, [_vm._v("months before")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }